// extracted by mini-css-extract-plugin
export default {"featureListContainer":"FeatureList_modern_featureListContainer__c2PyY","successIcon":"FeatureList_modern_successIcon__5kIhu"};